import axios from "axios";
import { DataResponse } from "models/common/responseObjects";
import { FeatureFlagView } from "models/dbModels/featureFlags/FeatureFlag";

export class FeatureFlagsApi {
    static FeatureFlagsSearch = async () => axios.post<DataResponse<FeatureFlagView[]>>(`api/v1/FeatureFlags/FeatureFlagsSearch`);
}